export default __webpack_public_path__ + "static/media/scale-with-bank-and-hdb.690173cd.svg";